import { motion } from "framer-motion";
import styled from "styled-components";
import { device } from "../../../../style";

export const Header = styled(motion.div)`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: 15px;
  margin-bottom: 15px;
  position: relative;

  @media ${device.laptop} {
    flex-direction: row;
    margin-bottom: 21px;
  }
`;

export const WalletWrapper = styled.div`
  width: 100%;
  display: flex;
  padding-bottom: 11.5px;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #afbdd733;
  gap: 12px;
`;

export const WalletConatiner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: flex-start;
  align-items: flex-start;
  flex: 1;
`;

export const Wallet = styled.div``;

export const BalanceContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 9px;
  justify-content: flex-start;
  align-items: flex-start;
  flex: 1;
`;

export const VerticalGreenLine = styled.div`
  height: 21px;
  width: 1px;
  background: #26a677;
  display: none;

  @media ${device.tablet} {
    display: block;
  }
`;

export const Balance = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  gap: 2px;

  @media ${device.tablet} {
    flex-direction: row;
    gap: 19px;
    align-items: center;
  }
`;
